<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-head">Contents</p>
<p class="toc-front" id="ackn-1"><a href="#/SomeGirlsDo_ackn1">Acknowledgements</a></p>
<p class="toc-chapter" id="prol-1"><a href="#/SomeGirlsDo_prol1">Prologue</a></p>
<p class="toc-chapter" id="chap-1"><a href="#/SomeGirlsDo_chap1">Chapter 1</a></p>
<p class="toc-chapter" id="chap-2"><a href="#/SomeGirlsDo_chap2">Chapter 2</a></p>
<p class="toc-chapter" id="chap-3"><a href="#/SomeGirlsDo_chap3">Chapter 3</a></p>
<p class="toc-chapter" id="chap-4"><a href="#/SomeGirlsDo_chap4">Chapter 4</a></p>
<p class="toc-chapter" id="chap-5"><a href="#/SomeGirlsDo_chap5">Chapter 5</a></p>
<p class="toc-chapter" id="chap-6"><a href="#/SomeGirlsDo_chap6">Chapter 6</a></p>
<p class="toc-chapter" id="chap-7"><a href="#/SomeGirlsDo_chap7">Chapter 7</a></p>
<p class="toc-chapter" id="chap-8"><a href="#/SomeGirlsDo_chap8">Chapter 8</a></p>
<p class="toc-chapter" id="chap-9"><a href="#/SomeGirlsDo_chap9">Chapter 9</a></p>
<p class="toc-chapter" id="chap-10"><a href="#/SomeGirlsDo_chap10">Chapter 10</a></p>
<p class="toc-chapter" id="chap-11"><a href="#/SomeGirlsDo_chap11">Chapter 11</a></p>
<p class="toc-chapter" id="chap-12"><a href="#/SomeGirlsDo_chap12">Chapter 12</a></p>
<p class="toc-chapter" id="chap-13"><a href="#/SomeGirlsDo_chap13">Chapter 13</a></p>
<p class="toc-chapter" id="chap-14"><a href="#/SomeGirlsDo_chap14">Chapter 14</a></p>
<p class="toc-chapter" id="chap-15"><a href="#/SomeGirlsDo_chap15">Chapter 15</a></p>
<p class="toc-chapter" id="chap-16"><a href="#/SomeGirlsDo_chap16">Chapter 16</a></p>
<p class="toc-chapter" id="chap-17"><a href="#/SomeGirlsDo_chap17">Chapter 17</a></p>
<p class="toc-chapter" id="chap-18"><a href="#/SomeGirlsDo_chap18">Chapter 18</a></p>
<p class="toc-chapter" id="chap-19"><a href="#/SomeGirlsDo_chap19">Chapter 19</a></p>
<p class="toc-chapter" id="chap-20"><a href="#/SomeGirlsDo_chap20">Chapter 20</a></p>
<p class="toc-chapter" id="chap-21"><a href="#/SomeGirlsDo_chap21">Chapter 21</a></p>
<p class="toc-chapter" id="chap-22"><a href="#/SomeGirlsDo_chap22">Chapter 22</a></p>
<p class="toc-chapter" id="epil-1"><a href="#/SomeGirlsDo_epil1">Epilogue</a></p>
<p class="toc-front" id="auth-1"><a href="#/SomeGirlsDo_auth1">About the Author</a></p>
<p class="toc-front" id="teas-1"><a href="#/SomeGirlsDo_teas1">A Preview of "When She’s Bad"</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SomeGirlsDo_toc.vue?8f7806fe